import { PaginationTypes } from "@Shared/Pagination-Types";
import { useState, useEffect } from "react";

const usePeoplePagination = ({
  items = [],
  maxNumberOfItems = 4,
  pagination,
}) => {
  const [page, setPage] = useState(1);

  const indexOfLast = page * maxNumberOfItems;
  const indexOfFirst = indexOfLast - maxNumberOfItems;
  const maxPage = Math.ceil(items.length / maxNumberOfItems);
  const hasNextPage = items.length > maxNumberOfItems;

  useEffect(() => {
    setPage(1);
  }, [maxNumberOfItems, pagination]);

  const dynamicIndexOfFirst = {
    [PaginationTypes.INFINITE]: 0,
    [PaginationTypes.CAROUSEL]: indexOfFirst,
  };

  const itemsPaginated = items.slice(
    dynamicIndexOfFirst[pagination],
    indexOfLast
  );

  return {
    itemsPaginated,
    maxPage,
    hasNextPage,
    page,
    setPage,
  };
};

export default usePeoplePagination;
